"use strict";
define(
    'stores/viewbuncee',[
        "jquery",
        "stores/store",
        "actions/viewbuncee",
        "constants/actiontypes"
    ],
    function ($, StoreBase, Action, Constants)
    {
        Store.prototype = new StoreBase();
        Store.constructor = Store;

        function Store (params)
        {
            // Call parent constructor
            StoreBase.call(this, params);

            // Setup the instance
            this.buncee = window.appData.buncee.data;
            this.comments = [];
            this.tags = window.appData.buncee.data.tags;
            this.likes = 0;
            this.likeState = false;

            this.registerDispatchListener(function (action) {
                switch(action.actionType) {
                    case Constants.SET_COMMENTABLE:
                        this.setCommentable(action.data);
                        break;
                    case Constants.SET_COPYABLE:
                        this.setCopyable(action.data);
                        break;
                    case Constants.SET_PRIVACY:
                        this.setPrivacy(action.data);
                        break;
                    case Constants.ADD_COMMENT:
                        this.addComment(action.data);
                        break;
                    case Constants.REMOVE_COMMENT:
                        this.removeComment(action.data);
                        break;
                    case Constants.ADD_TAG:
                        this.addTag(action.data);
                        break;
                    case Constants.REMOVE_TAG:
                        this.removeTag(action.data);
                        break;
                    case Constants.SET_LIKE_COUNT:
                        this.setLikeCount(action.data);
                        break;
                    case Constants.TOGGLE_LIKE_STATE:
                        this.toggleLikeState(action.data);
                        break;
                }
                this.event.emit("change");
            }.bind(this));

            this.action = new Action();
        }

        Store.prototype.setCommentable = function(value) {
            this.buncee.commentable = value
        };

        Store.prototype.setCopyable = function(value) {
            this.buncee.copyable = value
        };

        Store.prototype.setPrivacy = function(value) {
            this.buncee.privacy_level = value;
        };

        Store.prototype.getBuncee = function() {
            return this.buncee;
        };

        Store.prototype.getComments = function() {
            return this.comments;
        };

        Store.prototype.addComment = function(comment) {
            this.comments.push(comment);
        };

        Store.prototype.removeComment = function(data) {
            this.comments = _.without(this.comments, _.findWhere(this.comments, {guid: data.guid}));
        };

        Store.prototype.getTags = function() {
            return this.tags;
        };

        Store.prototype.addTag = function(tag) {
            this.tags.push(tag);
        };

        Store.prototype.removeTag = function(data) {
            this.tags = _.without(this.tags, _.findWhere(this.tags, {guid: data.guid}));
        };

        Store.prototype.setLikeCount = function(data) {
            this.likes = data;
        }

        Store.prototype.getLikeCount = function() {
            return this.likes
        }

        Store.prototype.toggleLikeState = function(data) {
            if(this.likeState) {
                this.likeState = false;
                this.likes--;
            } else {
                this.likeState = true;
                if(data.increment) {
                    this.likes++;    
                }
            }
        }

        Store.prototype.getLikeState = function(data) {
            return this.likeState;
        }

        Store.prototype.getViews = function() {
            return this.buncee.views || 0;
        };

        return Store;
    }
);
